/**
 * Saves a blob as a file download: a temporary object URL on a clicked link,
 * revoked once the click has been handled.
 *
 * @param blob - The file's contents.
 * @param fileName - The name the browser saves it under.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener';
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
